module.exports = __webpack_public_path__ + "static/fonts/DingTalk-JinBuTi.a0bb3c3.ttf";